<template>
	<div>
		<statistics-partials-plain partial-title="GIR" :partial-value="roundGreens.gir"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 3 Chances" :partial-value="roundGreens.par_3_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 3 Hit" :partial-value="roundGreens.par_3_hit"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 3%" :partial-value="roundGreens.par_3_percentage"></statistics-partials-plain>

		<statistics-partials-plain partial-title="Par 4 Chances" :partial-value="roundGreens.par_4_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 4 Hit" :partial-value="roundGreens.par_4_hit"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 4%" :partial-value="roundGreens.par_4_percentage"></statistics-partials-plain>

		<statistics-partials-plain partial-title="Par 5 Chances" :partial-value="roundGreens.par_5_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 5 Hit" :partial-value="roundGreens.par_5_hit"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Par 5%" :partial-value="roundGreens.par_5_percentage"></statistics-partials-plain>

	</div>
</template>
<script>
export default {
	name: "StatisticsGreens",
	props: {
		roundGreens: {
			type: Object,
			required: true
		}
	},
	components: {
		'statistics-partials-plain': () => import(/* webpackChunkName: "StatisticsFairways" */ './Partials/Plain'),
	}
}
</script>
